<template>
  <!-- Mobile -->
  <v-sheet
    v-if="$vuetify.breakpoint.smAndDown && providers && providers.length > 0"
    class="transparent mt-4"
    width="100%"
  >
    <!-- Nome da categoria e ver todos -->
    <div class="d-flex justify-space-between align-end mb-1 pl-2">
      <div
        :class="
          $vuetify.breakpoint.mobile ? 'subtitle-1 font-weight-bold' : 'text-h6'
        "
        style="filter: blur(0)"
      >
        {{ $t("newCasino.providers") }}
      </div>
      <div style="filter: blur(0)">
        <v-hover v-slot="{ hover }">
          <v-btn
            text
            :color="hover ? 'primary' : ''"
            :class="$vuetify.breakpoint.xs ? 'my-1 mr-2' : ''"
            small
            outlined
            rounded
            @click="goProviders()"
          >
            <!-- {{ $t("seeAllGamesCategory") }} -->
            {{ providers.length }}
            {{ $t("newCasino.providers") }}
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-hover>
      </div>
    </div>

    <!-- Listagem dos Provedor (MOBILE) -->
    <div class="providers-slider d-flex">
      <div v-for="(provider, index) in providers" :key="index">
        <v-card
          class="d-flex flex-column align-center justify-center py-2 px-4 ml-2"
          elevation="0"
          @click="allGamesProvider(provider.id)"
          :style="{
            backgroundColor: 'transparent',
            borderRadius: '8px',
          }"
          outlined
          width="136px"
        >
          <div
            :style="{
              ...styleCardProvider,
              backgroundImage: `url(${provider.src})`,
            }"
          ></div>
          <!-- <img :src="provider.src" /> -->
        </v-card>
      </div>
    </div>
  </v-sheet>

  <!-- Desktop -->
  <v-sheet
    v-else-if="!$vuetify.breakpoint.smAndDown"
    class="transparent"
    width="100%"
  >
    <!-- Nome da categoria e ver todos -->
    <div class="d-flex justify-space-between justify-center align-center">
      <div
        :class="[
          'nameProviders',
          $vuetify.breakpoint.xs
            ? 'subtitle-1 font-weight-bold my-1 pl-2'
            : 'text-h6 font-weight-bold my-3'
        ]"
        style="filter: blur(0)"
        @click="goProviders()"
      >
        {{ $t("newCasino.providers") }}
      </div>
      <div style="filter: blur(0)">
        <v-hover v-slot="{ hover }">
          <v-btn
            text
            :color="hover ? 'primary' : ''"
            small
            outlined
            rounded
            class="px-2 caption"
            @click="goProviders()"
          >
            <!-- {{ $t("seeAllGamesCategory") }} -->
            {{ providers.length }}
            {{ $t("newCasino.providers") }}
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-hover>
      </div>
    </div>

    <!-- Listagem dos jogos -->
    <v-slide-group class="sliderProvidersDesktop" v-model="model">
      <template v-slot:prev>
        <v-hover v-slot="{ hover }">
          <v-icon :color="hover ? 'primary' : ''" :size="32">
            mdi-chevron-left
          </v-icon>
        </v-hover>
      </template>
      <template v-slot:next>
        <v-hover v-slot="{ hover }">
          <v-icon :color="hover ? 'primary' : ''" :size="32">
            mdi-chevron-right
          </v-icon>
        </v-hover>
      </template>
      <!-- Listagem dos Provedor (DESKTOP) -->
      <v-slide-item v-for="provider in providers" :key="provider.id">
        <v-hover v-slot="{ hover, props }">
          <v-card
            class="cardProvider d-flex flex-column align-center justify-center align-center mr-4 py-3 px-6"
            v-bind="props"
            width="166px"
            outlined
            @click="allGamesProvider(provider.id)"
            :style="{
              backgroundColor: 'transparent',
              borderRadius: '16px',
            }"
          >
            <div
              class="cardProviderBackgroundImage"
              :style="{
                ...styleCardProvider,
                '--providerBackground': `url(${hover ?
                  provider.srcColor :
                  provider.src
                })`,
              }"
            ></div>
            <!-- <span>{{ provider.numberOfGames }}</span> -->
          </v-card>
        </v-hover>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>
<script>
export default {
  name: "ProvidersSlider",
  props: ["providers", "onGame"],
  data: () => ({
    model: 0,
    styleCardProvider: {
      width: "100%",
      height: "64px",
      backgroundSize: "contain",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
    },
  }),
  methods: {
    goProviders() {
      this.$router.push({ name: "casinoProviders" });
    },
    allGamesProvider(providerId) {
      this.$router.push({
        name: "casinoProvider",
        params: { providerId },
      });
    },
  },
};
</script>
<style scoped>
:root {
  --providerBackground: '';
}
.nameProviders:hover {
  cursor: pointer;
  color: var(--v-primary-base);
}
.cardProviderBackgroundImage {
  background-image: var(--providerBackground);
  transition: all 0.5s linear;
}
.providers-slider {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
}
.providers-slider::-webkit-scrollbar {
  display: none;
  width: 0px;
  background: transparent;
}
.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__image {
  height: 100%;
}
.fade-enter-active {
  transition: opacity 0.2s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* .sliderProvidersDesktop >>> div.v-slide-group__prev {
  margin-left: -52px !important;
}
.sliderProvidersDesktop >>> .v-slide-group__next {
  margin-right: -52px !important;
} */
</style>
